function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { createContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { eventHub, getAnalytics } from '@miro-site/analytics';
import { useBehaviourAutoTracking } from '@miro-site/shared-web-tracking';
import { SplitIoProvider } from '@miro-site/splitio';
import { getOneTrustDataDomainScript } from './onetrust';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ServicesContext = /*#__PURE__*/createContext({
  analytics: undefined,
  eventHub: undefined
});
var userActions = ['mousemove', 'keydown', 'click', 'touchstart'];
export var ServicesProvider = function ServicesProvider(_ref) {
  var children = _ref.children,
      _ref$withAnalytics = _ref.withAnalytics,
      withAnalytics = _ref$withAnalytics === void 0 ? true : _ref$withAnalytics,
      _ref$withUserTracking = _ref.withUserTracking,
      withUserTracking = _ref$withUserTracking === void 0 ? false : _ref$withUserTracking,
      _ref$withSplitIo = _ref.withSplitIo,
      withSplitIo = _ref$withSplitIo === void 0 ? true : _ref$withSplitIo;
  var router = useRouter();
  useBehaviourAutoTracking(withUserTracking);

  var _useState = useState(false),
      oneTrustIsLoaded = _useState[0],
      setOneTrustIsLoaded = _useState[1];

  var _useState2 = useState(false),
      loadOneTrust = _useState2[0],
      setLoadOneTrust = _useState2[1];

  var _useState3 = useState(false),
      loadAnalytics = _useState3[0],
      setLoadAnalytics = _useState3[1]; // Directly load Split IO to avoid screen flickering with experiments above the fold


  var loadSplitIo = withSplitIo && !!process.env.NEXT_PUBLIC_SPLITIO_CLIENT_KEY; // GTM

  var analytics = getAnalytics(); // Add listener to trigger "page view" at route change

  useEffect(function () {
    if (!eventHub) {
      return;
    } // Trigger page view for initial load


    eventHub.page(); // Setup callback for route changes

    router.events.on('routeChangeComplete', eventHub.page); // Remove event tracking when provider is unmounted

    return function () {
      router.events.off('routeChangeComplete', eventHub.page);
    };
  }, [eventHub]); // Add listener to load `OneTrust`

  useEffect(function () {
    var _iterator = _createForOfIteratorHelper(userActions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var action = _step.value;
        window.addEventListener(action, handleUserAction);
      } // Return clean-up function

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return removeInteractionListeners;
  }, []); // When One Trust is loaded, enable analytics to be loaded

  useEffect(function () {
    if (!oneTrustIsLoaded) {
      return;
    }

    setLoadAnalytics(withAnalytics);
  }, [oneTrustIsLoaded]); // Initialize analytics providers

  useEffect(function () {
    if (loadAnalytics && analytics) {
      analytics.initialize();
    }
  }, [loadAnalytics, analytics]); // Handler initial user action

  var handleUserAction = function handleUserAction(_e) {
    // Enable One Trust script to be loaded
    setLoadOneTrust(true); // Remove listeners to avoid repeating this function

    removeInteractionListeners();
  }; // Clean up function to remove the user action listeners


  var removeInteractionListeners = function removeInteractionListeners() {
    var _iterator2 = _createForOfIteratorHelper(userActions),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var action = _step2.value;
        window.removeEventListener(action, handleUserAction);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };

  var handleOneTrustOnLoad = function handleOneTrustOnLoad() {
    // Update flag to load other scripts only when OneTrust is initialized
    var checkOneTrustInit = setInterval(function () {
      if (window.OneTrust) {
        setOneTrustIsLoaded(true);
        window.dispatchEvent(new CustomEvent('oneTrustLoaded')); // Clear interval to stop looping

        clearInterval(checkOneTrustInit);
      }
    }, 300);
  };

  var content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Script, {
      strategy: "beforeInteractive" // Removing next/script from first render negatively impacts performance.
      // We are explicitly using CDN host to load optanonWrapper using next/script.
      ,
      src: "https://static-website.miro.com/miro-site-lp-build-assets/scripts/optanonWrapper.js"
    }), loadOneTrust && /*#__PURE__*/_jsx(Script, {
      src: "https://cdn.cookielaw.org/consent/4133a0ef-6999-461d-909d-24f2b05bbc15/otSDKStub.js",
      "data-document-language": "true",
      charSet: "UTF-8",
      "data-domain-script": getOneTrustDataDomainScript(),
      onLoad: handleOneTrustOnLoad
    }), children]
  });

  if (loadSplitIo) {
    content = /*#__PURE__*/_jsx(SplitIoProvider, {
      children: content
    });
  }

  return /*#__PURE__*/_jsx(ServicesContext.Provider, {
    value: {
      analytics: analytics,
      eventHub: eventHub
    },
    children: content
  });
};